import day from "dayjs";

const maybeJoin = (label, values) => {
  if (!values || values.length === 0) return "";
  return `${label}: ${values.join(", ")}`;
};

export const calendarEventToFollowupDefaults =
  ({ profile } = {}) =>
  (event) => {
    const dueOn = event?.end ? day.unix(event.end) : null;

    const lines = [
      event?.subject ? `Subject: ${event.subject}` : "",
      event?.organizer?.length ? maybeJoin("Organizer", event.organizer) : "",
      event?.attendees?.length ? maybeJoin("Attendees", event.attendees) : "",
      event?.location ? `Location: ${event.location}` : "",
      event?.webLink ? `Link: ${event.webLink}` : "",
    ].filter(Boolean);

    return {
      assigneeId: profile?._id || null,
      dueOn,
      integrations: event?.id
        ? [
            {
              type: "microsoft_graph_event",
              payload: {
                eventId: event.id,
                userId: profile?._id || null,
              },
            },
          ]
        : [],
      task: lines.join("\n"),
    };
  };
